import React, { useState } from "react";
import { map } from "lodash";
import { Grid, GridItem } from "../../components/common";
import { ListItem, CardList } from "./ListItem";
import { documents, menuNav } from "./DocumentList";

const DocumentEducationView = () => {
  const [active, setActive] = useState(1);
  const { serviceRequest, training, educationCenter } = documents;

  const renderList = (list) =>
    map(list, ({ title, url }, idx) => (
      <ListItem title={title} url={url} key={idx} isEducation/>
    ));

  return (
    <section className="documents-section">
      <div className="container">
        <Grid>
          <GridItem xsmall={12} small={6} medium={3}>
            <nav className="section-nav">
              <ul className="section-nav__list">
                {map(menuNav, ({ title, url, id }) => {
                  return (
                    <li
                      onClick={() => setActive(id)}
                      className={`section-nav__item ${
                        id === active && "active"
                      }`}
                      key={id}
                    >
                      <a href={url}>{title}</a>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </GridItem>
          <GridItem xsmall={12} small={6} medium={9}>
          <CardList title={"Service Request"} idName={"serviceRequest"}>
              {renderList(serviceRequest)}
            </CardList>
            <CardList title={"Training"} idName={"training"}>
              {renderList(training)}
            </CardList>
            <CardList title={"Education Center"} idName={"educationCenter"}>
              {renderList(educationCenter)}
            </CardList>
          </GridItem>
        </Grid>
      </div>
    </section>
  );
};

export default DocumentEducationView;
